import { Component, computed, inject, signal, effect, OnInit, Injector } from '@angular/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { DatePipe, DecimalPipe } from '@angular/common';
import {RevenueWidgetsService} from "../../../core/revenue/services/revenue-widget.service";
import { MatTooltipModule } from '@angular/material/tooltip';
import {HolidaysService} from "../../../core/base/holidays.service";
import {UserService} from "../../../core/user/services/user.service";


@Component({
  imports: [MatProgressBarModule, DatePipe, DecimalPipe, MatTooltipModule],
  selector: 'app-target-widget',
  templateUrl: './target-widget.component.html',
  styleUrl: './target-widget.component.scss',
})
export class TargetWidgetComponent implements OnInit {
  private revenueWidgetService: RevenueWidgetsService = inject(RevenueWidgetsService);
  protected holidaysService = inject(HolidaysService);
  protected userService: UserService = inject(UserService);
  private injector = inject(Injector);

  remainingWorkingDays = computed(() => {
    return this.getRemainingWorkingDaysInMonth();
  });

  isEndOfMonth = computed(() => {
    return this.remainingWorkingDays() < 5;
  });
  revenueData = computed(() => {
    const kpis = this.revenueWidgetService.revenueKpis();
    const rxPacketCount = kpis?.rx_packet_count ?? 0;
    const targetRxPackets = kpis?.target_rx_packets ?? 0;
    const rxPacketPercentage = Math.floor(targetRxPackets > 0 ? (rxPacketCount / targetRxPackets) * 100 : 0);

    return {
      rx_packet_count: rxPacketCount,
      target_rx_packets: targetRxPackets,
      rx_packet_percentage: rxPacketPercentage,
      rx_packet_delta: targetRxPackets - rxPacketCount,
      updated_at: kpis?.updated_at ?? '',
      currentMonth: this.revenueWidgetService.currentMonth(),
      idf: kpis?.idf
    };
  });
  progressColor = computed(() => {
    const percentage = this.revenueData().rx_packet_percentage;
    const isEndOfMonth = this.isEndOfMonth();

    if (!isEndOfMonth) {
      return '#62c3d5';
    }
    if (percentage < 80) {
      return '#d53f15';
    }
    if (percentage < 100) {
      return '#fbba00';
    }
    return '#92d400';
  });

  private _sessionShowCelebration = signal(false);
  sessionShowCelebration = this._sessionShowCelebration.asReadonly();

  ngOnInit() {
    effect(() => {
      const change = this.revenueData();
      if (change) {
        this.checkCelebrationStatus();
      }
    }, { injector: this.injector });
  }

  private getRemainingWorkingDaysInMonth(): number {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    const lastDay = new Date(year, month + 1, 0);

    let workingDaysCount = 0;
    let currentDate = new Date(today);

    while (currentDate <= lastDay) {
      const dayOfWeek = currentDate.getDay();
      const isHoliday = this.holidaysService.isHoliday(currentDate);

      if (dayOfWeek >= 1 && dayOfWeek <= 5 && !isHoliday) {
        workingDaysCount++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return workingDaysCount;
  }

  checkCelebrationStatus() {
    this._sessionShowCelebration.set(false);
    const idf = this.revenueData().idf;

    const currentMonth = new Date().getMonth();
    const storedMonth = localStorage.getItem('celebrationMonth');
    const alreadyCelebrated = localStorage.getItem(idf + '_targetCelebrated') === 'true';

    if (storedMonth !== currentMonth.toString()) {
      localStorage.setItem('celebrationMonth', currentMonth.toString());
      localStorage.setItem(idf + '_targetCelebrated', 'false');
      return;
    }

    if (this.revenueData().rx_packet_percentage >= 100 && !alreadyCelebrated) {
      this._sessionShowCelebration.set(true);
      localStorage.setItem(idf + '_targetCelebrated', 'true');

    } else if(!alreadyCelebrated && this.revenueData().rx_packet_percentage < 100) {
      this._sessionShowCelebration.set(false);
      localStorage.setItem(idf + '_targetCelebrated', 'false');
    }
  }
}

